webpackJsonp([85208315989496],{

/***/ 68:
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(156);
	var parse = __webpack_require__(155);
	var formats = __webpack_require__(68);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	var formats = __webpack_require__(68);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	var encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(622);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContributeBanner = function (_Component) {
	  _inherits(ContributeBanner, _Component);
	
	  function ContributeBanner() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContributeBanner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.dismissBanner = function () {
	      _this.setState({ open: false });
	      localStorage.setItem('contribute-banner-dismissed', 'true');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContributeBanner.prototype.componentDidMount = function componentDidMount() {
	    if (typeof localStorage !== 'undefined') {
	      var dismissed = localStorage.getItem('contribute-banner-dismissed');
	      if (!dismissed) {
	        this.setState({ open: true });
	      }
	    }
	  };
	
	  ContributeBanner.prototype.render = function render() {
	    return this.state.open && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Contribute your knowledge'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          {
	            style: {
	              fontSize: '14px',
	              margin: '0.5rem 0'
	            }
	          },
	          'Are you passionate about Whitefriars glass, know a Whitefriars stained glass window near you or remember the factory? We need to your knowledge. All of our information is contributed by people just like you. Get started today, it only takes a few minutes.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.buttons },
	          _react2.default.createElement(_pillButton2.default, {
	            small: true,
	            text: 'Get started',
	            tag: _gatsbyLink2.default,
	            to: '/contribute'
	          }),
	          _react2.default.createElement(_pillButton2.default, {
	            small: true,
	            theme: 'black-ghost',
	            text: 'Close',
	            onClick: this.dismissBanner
	          })
	        )
	      )
	    );
	  };
	
	  return ContributeBanner;
	}(_react.Component);
	
	exports.default = ContributeBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribute-banner----styles-module---container---1A2gZ","inner":"src-components-contribute-banner----styles-module---inner---fz1Zd","buttons":"src-components-contribute-banner----styles-module---buttons---3vcXI"};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(235);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Search = __webpack_require__(57);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _SelectArrows = __webpack_require__(85);
	
	var _SelectArrows2 = _interopRequireDefault(_SelectArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      options = _ref.options,
	      selectedValue = _ref.selectedValue,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'select',
	        { id: id, name: id, onChange: onChange },
	        options.map(function (_ref2, index) {
	          var text = _ref2.text,
	              value = _ref2.value;
	          return _react2.default.createElement(
	            'option',
	            { key: index, value: value },
	            text
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.arrowContainer },
	        _react2.default.createElement(_SelectArrows2.default, { size: 16 })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-drop-down----styles-module---container---fk7bs","arrowContainer":"src-components-drop-down----styles-module---arrowContainer---awf5L"};

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(150);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Search = __webpack_require__(57);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      applySearchTerm = _ref.applySearchTerm;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: _stylesModule2.default.container,
	      onSubmit: function onSubmit(event) {
	        event.preventDefault();
	        applySearchTerm();
	      }
	    },
	    _react2.default.createElement(
	      'label',
	      { className: 'a11y-hide', htmlFor: 'search-term' },
	      'Search term'
	    ),
	    _react2.default.createElement('input', {
	      type: 'text',
	      id: 'search-term',
	      name: 'search-term',
	      placeholder: 'Enter a search term',
	      value: value,
	      onChange: onChange
	    }),
	    _react2.default.createElement(
	      'button',
	      { onClick: applySearchTerm },
	      _react2.default.createElement(_Search2.default, { size: 16 })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-search-box----styles-module---container---2CNmU"};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(633);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _Chevron = __webpack_require__(327);
	
	var _Chevron2 = _interopRequireDefault(_Chevron);
	
	var _Checkbox = __webpack_require__(159);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchOption = function SearchOption(_ref) {
	  var type = _ref.type,
	      id = _ref.id,
	      label = _ref.label,
	      value = _ref.value,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(
	    'li',
	    { className: _stylesModule2.default.searchOption },
	    _react2.default.createElement(
	      'label',
	      {
	        htmlFor: id,
	        onClick: function onClick(event) {
	          event.preventDefault();
	          onChange(event);
	        }
	      },
	      _react2.default.createElement(_Checkbox2.default, {
	        color: '#282c34',
	        type: type,
	        id: id,
	        value: value,
	        onChange: onChange
	      }),
	      _react2.default.createElement(
	        'span',
	        null,
	        label
	      )
	    )
	  );
	};
	
	var SearchFilter = function (_Component) {
	  _inherits(SearchFilter, _Component);
	
	  function SearchFilter() {
	    _classCallCheck(this, SearchFilter);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      open: true,
	      openHeight: null
	    };
	    return _this;
	  }
	
	  SearchFilter.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({
	        open: document.body.clientWidth >= 1024,
	        openHeight: _this2.listElement.offsetHeight + 2
	      });
	    }, 500);
	  };
	
	  SearchFilter.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        amountSelected = _props.amountSelected,
	        clearAll = _props.clearAll,
	        filters = _props.filters;
	    var _state = this.state,
	        open = _state.open,
	        openHeight = _state.openHeight;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container + ' ' + (open ? _stylesModule2.default.open : '') },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.heading },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _stylesModule2.default.openButton,
	            onClick: function onClick() {
	              return _this3.setState({ open: !open });
	            }
	          },
	          _react2.default.createElement(_Chevron2.default, { color: '#282c34' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _stylesModule2.default.title },
	          title,
	          amountSelected > 0 && ' (' + amountSelected + ')'
	        ),
	        amountSelected > 0 && _react2.default.createElement(
	          _Tooltip2.default,
	          { text: 'Clear all' },
	          _react2.default.createElement(
	            'button',
	            { onClick: clearAll },
	            _react2.default.createElement(_Cross2.default, { color: '#282c34' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _stylesModule2.default.list,
	          style: {
	            height: open ? openHeight + 'px' : '0px'
	          }
	        },
	        _react2.default.createElement(
	          'ul',
	          {
	            ref: function ref(element) {
	              _this3.listElement = element;
	            }
	          },
	          filters.sort(function (a, b) {
	            return a.text.localeCompare(b.text);
	          }).map(function (_ref2, index) {
	            var text = _ref2.text,
	                value = _ref2.value,
	                onChange = _ref2.onChange;
	            return _react2.default.createElement(SearchOption, {
	              key: index,
	              type: 'checkbox',
	              id: _this3.props.title.replace(/\s/, '') + index,
	              label: text,
	              value: value,
	              onChange: onChange
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return SearchFilter;
	}(_react.Component);
	
	exports.default = SearchFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-search-filter----styles-module---container---X1k_u","open":"src-components-search-filter----styles-module---open---2NQws","heading":"src-components-search-filter----styles-module---heading---SFgeq","title":"src-components-search-filter----styles-module---title---3okox","openButton":"src-components-search-filter----styles-module---openButton---QST46","list":"src-components-search-filter----styles-module---list---1sHwn","searchOption":"src-components-search-filter----styles-module---searchOption---py9Lj"};

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      style: { transformOrigin: '50% 50%', transform: 'scale(2)' },
	      fill: color,
	      d: 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _qs = __webpack_require__(154);
	
	var _stylesModule = __webpack_require__(652);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _dropDown = __webpack_require__(187);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _backgroundImage = __webpack_require__(100);
	
	var _backgroundImage2 = _interopRequireDefault(_backgroundImage);
	
	var _searchBox = __webpack_require__(124);
	
	var _searchBox2 = _interopRequireDefault(_searchBox);
	
	var _contributeBanner = __webpack_require__(321);
	
	var _contributeBanner2 = _interopRequireDefault(_contributeBanner);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _resultList = __webpack_require__(347);
	
	var _resultList2 = _interopRequireDefault(_resultList);
	
	var _searchControls = __webpack_require__(348);
	
	var _searchControls2 = _interopRequireDefault(_searchControls);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _Search = __webpack_require__(57);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _glass = __webpack_require__(129);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INITAL_AMOUNT_SHOWN = 10;
	var LOAD_MORE_INCREMENT_AMOUNT = 10;
	var ALLOWED_FILTERS = ['glassType', 'designer', 'colour', 'productionLocation', 'productionMethod', 'tablewareType'];
	
	var Glass = function (_Component) {
	  _inherits(Glass, _Component);
	
	  function Glass(props) {
	    _classCallCheck(this, Glass);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var query = (0, _qs.parse)(typeof location !== 'undefined' && location.search && location.search.slice(1));
	
	    var searchTerm = query.term || '';
	
	    var filters = {};
	
	    if (query.type && (query.type === 'WINDOW' || query.type === 'TABLEWARE')) {
	      filters.glassType = [query.type];
	    }
	
	    _this.state = {
	      searchTerm: searchTerm,
	      appliedSearchTerm: searchTerm,
	      sortBy: 'name:asc',
	      filters: filters,
	      amountShown: INITAL_AMOUNT_SHOWN,
	      results: (0, _glass2.default)(_glassData2.default, searchTerm, 'name:asc', filters),
	      mobileFiltersOpen: false
	    };
	    return _this;
	  }
	
	  Glass.prototype.componentWillMount = function componentWillMount() {
	    this.generateFilters();
	  };
	
	  Glass.prototype.render = function render() {
	    var _state = this.state,
	        amountShown = _state.amountShown,
	        results = _state.results;
	
	    var showingAll = amountShown >= results.length;
	    var amountShownText = 'Found ' + results.length + ' results';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Search Whitefriars Glass' }),
	      _react2.default.createElement(
	        'h1',
	        { className: 'a11y-hide' },
	        'Search Items'
	      ),
	      _react2.default.createElement(
	        _backgroundContainer2.default,
	        { src: _room2.default },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.header },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.searchBoxContainer },
	              _react2.default.createElement(_searchBox2.default, {
	                value: this.state.searchTerm,
	                onChange: this.updateSearchTerm,
	                applySearchTerm: this.applySearchTerm
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.sortByContainer },
	              _react2.default.createElement(_dropDown2.default, {
	                id: 'sort-by',
	                label: 'Sort by:',
	                options: [{ text: 'Name (A - Z)', value: 'name:asc' }, { text: 'Name (Z - A)', value: 'name:desc'
	                  // { text: 'Newest First', value: 'date:asc' },
	                  // { text: 'Oldest First', value: 'date:desc' },
	                }],
	                value: this.state.sortBy,
	                onChange: this.updateSortBy
	              })
	            ),
	            _react2.default.createElement(_pillButton2.default, {
	              className: _stylesModule2.default.mobileFiltersButton,
	              text: 'Set Filters',
	              onClick: this.toggleMobileFiltersOpen
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.bottom },
	        _react2.default.createElement(_searchControls2.default, {
	          filters: this.filters,
	          filterValues: this.state.filters,
	          updateFilters: this.updateFilters,
	          mobileFiltersOpen: this.state.mobileFiltersOpen,
	          toggleMobileFiltersOpen: this.toggleMobileFiltersOpen
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.results },
	          _react2.default.createElement(_contributeBanner2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.resultsHeader },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Results'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              amountShownText
	            )
	          ),
	          results.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.noResultsMessage },
	            'No results found. Couldn\'t find what you were looking for? Maybe help out by adding a new item.'
	          ) : _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.resultsList },
	            _react2.default.createElement(_resultList2.default, {
	              showMore: this.showMoreResults,
	              objects: results.slice(0, amountShown)
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.listEnd },
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.progress },
	                amountShownText
	              ),
	              !showingAll && _react2.default.createElement(_pillButton2.default, {
	                text: 'Load more',
	                onClick: this.showMoreResults
	              })
	            )
	          ),
	          _react2.default.createElement(_siteFooter2.default, { wrapped: true })
	        )
	      )
	    );
	  };
	
	  return Glass;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.generateFilters = function () {
	    var filters = {};
	
	    Object.values(_glassData2.default).forEach(function (object) {
	      return Object.entries(object.data || {}).filter(function (entry) {
	        return ALLOWED_FILTERS.includes(entry[0]);
	      }).forEach(function (entry) {
	        var key = entry[0];
	        var value = entry[1];
	        if (!filters[key]) {
	          filters[key] = [value];
	        } else if (!filters[key].includes(value)) {
	          filters[key].push(value);
	        }
	      });
	    });
	
	    _this2.setState({
	      filters: Object.keys(filters).reduce(function (result, filterName) {
	        var _extends2;
	
	        return _extends(result, (_extends2 = {}, _extends2[filterName] = _this2.state.filters[filterName] || [], _extends2));
	      }, {})
	    });
	
	    _this2.filters = filters;
	  };
	
	  this.updateSearchTerm = function (event) {
	    _this2.setState({ searchTerm: event.target.value });
	  };
	
	  this.updateFilters = function (filterName, filterList) {
	    var _extends3;
	
	    ga('send', {
	      hitType: 'event',
	      eventCategory: 'Search',
	      eventAction: 'Filter',
	      eventLabel: 'glassPage'
	    });
	    var newFilterValues = _extends({}, _this2.state.filters, (_extends3 = {}, _extends3[filterName] = filterList, _extends3));
	    _this2.setState(function (state) {
	      return { filters: newFilterValues };
	    });
	    _this2.performSearch();
	  };
	
	  this.applySearchTerm = function () {
	    _this2.setState(function (state) {
	      return { appliedSearchTerm: state.searchTerm };
	    });
	    _this2.performSearch();
	  };
	
	  this.updateSortBy = function (event) {
	    ga('send', {
	      hitType: 'event',
	      eventCategory: 'Search',
	      eventAction: 'SortOrder',
	      eventLabel: 'glassPage'
	    });
	    var value = event.target.value;
	    _this2.setState(function (state) {
	      return { sortBy: value };
	    });
	    _this2.performSearch();
	  };
	
	  this.performSearch = function () {
	    ga('send', {
	      hitType: 'event',
	      eventCategory: 'Search',
	      eventAction: 'Submit',
	      eventLabel: 'glassPage'
	    });
	    _this2.setState(function (state) {
	      return {
	        results: (0, _glass2.default)(_glassData2.default, state.appliedSearchTerm, state.sortBy, state.filters)
	      };
	    });
	  };
	
	  this.showMoreResults = function () {
	    _this2.setState({
	      amountShown: _this2.state.amountShown + LOAD_MORE_INCREMENT_AMOUNT
	    });
	  };
	
	  this.toggleMobileFiltersOpen = function () {
	    _this2.setState(function (state) {
	      return {
	        mobileFiltersOpen: !state.mobileFiltersOpen
	      };
	    });
	  };
	};
	
	exports.default = Glass;
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(650);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultItem = function (_Component) {
	  _inherits(ResultItem, _Component);
	
	  function ResultItem(props) {
	    _classCallCheck(this, ResultItem);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.ref = _react2.default.createRef();
	    return _this;
	  }
	
	  ResultItem.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.observer) {
	      this.props.observer.observe(this.ref.current);
	    }
	  };
	
	  ResultItem.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.observer && !!nextProps.observer) {
	      nextProps.observer.observe(this.ref.current);
	    } else if (!nextProps.observer && !!this.props.observer) {
	      this.props.observer.unobserve(this.ref.current);
	    }
	  };
	
	  ResultItem.prototype.render = function render() {
	    return _react2.default.createElement(
	      'li',
	      { ref: this.ref, className: _stylesModule2.default.item },
	      _react2.default.createElement(_itemLink2.default, {
	        id: this.props.id,
	        imageSizes: '(min-width: 1024px) 280px, (min-width: 768px) calc(33vw - 3rem), calc(50vw - 4rem)'
	      })
	    );
	  };
	
	  return ResultItem;
	}(_react.Component);
	
	var ResultList = function (_Component2) {
	  _inherits(ResultList, _Component2);
	
	  function ResultList(props) {
	    _classCallCheck(this, ResultList);
	
	    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));
	
	    _this2.observed = function (entries) {
	      if (entries[0] && entries[0].isIntersecting) {
	        _this2.props.showMore();
	      }
	    };
	
	    _this2.state = {
	      observer: null
	    };
	    return _this2;
	  }
	
	  ResultList.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      observer: new IntersectionObserver(this.observed, {
	        root: null,
	        rootMargin: '0px',
	        threshold: 0
	      })
	    });
	  };
	
	  ResultList.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'ul',
	      { className: _stylesModule2.default.container },
	      this.props.objects.map(function (object, index) {
	        return _react2.default.createElement(ResultItem, _extends({
	          key: object.id
	        }, object, {
	          observer: index === _this3.props.objects.length - 1 ? _this3.state.observer : null
	        }));
	      })
	    );
	  };
	
	  return ResultList;
	}(_react.Component);
	
	exports.default = ResultList;
	module.exports = exports['default'];

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-result-list----styles-module---container---RzwHU","item":"src-page-components-glass-result-list----styles-module---item---1TaTm"};

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames3 = __webpack_require__(12);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _searchFilter = __webpack_require__(324);
	
	var _searchFilter2 = _interopRequireDefault(_searchFilter);
	
	var _camelToDisplayText = __webpack_require__(190);
	
	var _camelToDisplayText2 = _interopRequireDefault(_camelToDisplayText);
	
	var _textMapping = __webpack_require__(192);
	
	var _textMapping2 = _interopRequireDefault(_textMapping);
	
	var _stylesModule = __webpack_require__(651);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toggleListValue = function toggleListValue(list, value) {
	  return list.includes(value) ? list.filter(function (item) {
	    return item !== value;
	  }) : [value].concat(list);
	};
	
	var SearchControls = function (_Component) {
	  _inherits(SearchControls, _Component);
	
	  function SearchControls() {
	    _classCallCheck(this, SearchControls);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SearchControls.prototype.render = function render() {
	    var _classnames, _classnames2;
	
	    var _props = this.props,
	        filters = _props.filters,
	        filterValues = _props.filterValues,
	        updateFilters = _props.updateFilters,
	        mobileFiltersOpen = _props.mobileFiltersOpen;
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames4.default)(_stylesModule2.default.filters, (_classnames = {}, _classnames[_stylesModule2.default.trayOpen] = mobileFiltersOpen, _classnames))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.header },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Filters'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.props.toggleMobileFiltersOpen },
	            'Close'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          Object.keys(filters).map(function (filterName) {
	            return _react2.default.createElement(_searchFilter2.default, {
	              key: filterName,
	              title: (0, _camelToDisplayText2.default)(filterName),
	              amountSelected: filterValues[filterName].length,
	              clearAll: function clearAll() {
	                return updateFilters(filterName, []);
	              },
	              filters: filters[filterName].reduce(function (list, current) {
	                if (current.includes(',')) {
	                  var values = current.split(',').map(function (value) {
	                    return value.trim();
	                  });
	
	                  var newList = list;
	                  values.forEach(function (value) {
	                    if (!list.includes(value)) {
	                      newList = list.concat(value);
	                    }
	                  });
	
	                  return newList;
	                } else {
	                  return list.concat(current);
	                }
	              }, []).map(function (filterValue) {
	                return {
	                  // Text transform if needed
	                  text: (0, _textMapping2.default)(filterName, filterValue),
	
	                  // Logic to show selected or not
	                  value: filterValues[filterName].includes(filterValue),
	
	                  // On change for individual selection
	                  onChange: function onChange() {
	                    return updateFilters(filterName, toggleListValue(filterValues[filterName], filterValue));
	                  }
	                };
	              })
	            });
	          })
	        )
	      ),
	      _react2.default.createElement('div', {
	        className: (0, _classnames4.default)(_stylesModule2.default.exitPanel, (_classnames2 = {}, _classnames2[_stylesModule2.default.open] = mobileFiltersOpen, _classnames2)),
	        onClick: this.props.toggleMobileFiltersOpen
	      })
	    );
	  };
	
	  return SearchControls;
	}(_react.Component);
	
	exports.default = SearchControls;
	module.exports = exports['default'];

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filters":"src-page-components-glass-search-controls----styles-module---filters---3nett","trayOpen":"src-page-components-glass-search-controls----styles-module---trayOpen---2DccL","exitPanel":"src-page-components-glass-search-controls----styles-module---exitPanel---mHu6i","open":"src-page-components-glass-search-controls----styles-module---open---UDUjn","header":"src-page-components-glass-search-controls----styles-module---header---P7XZr"};

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-page-components-glass----styles-module---header---27StN","searchBoxContainer":"src-page-components-glass----styles-module---searchBoxContainer---_69-0","bottom":"src-page-components-glass----styles-module---bottom---RtIBv","resultsHeader":"src-page-components-glass----styles-module---resultsHeader---1GCQU","listEnd":"src-page-components-glass----styles-module---listEnd---2RqcF","progress":"src-page-components-glass----styles-module---progress---3xzqd","results":"src-page-components-glass----styles-module---results---14L3O","resultsList":"src-page-components-glass----styles-module---resultsList---3-nq2","noResultsMessage":"src-page-components-glass----styles-module---noResultsMessage---2seKd","mobileFiltersButton":"src-page-components-glass----styles-module---mobileFiltersButton---2uKlH","sortByContainer":"src-page-components-glass----styles-module---sortByContainer---Z2u6r"};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _glass = __webpack_require__(346);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _glass2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (string) {
	  return string.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
	    return str.toUpperCase();
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textMapping = function textMapping(filterName, filterValue) {
	  var text = void 0;
	
	  if (filterName === 'glassType') {
	    text = _text2.default.MAPPINGS.GLASS_TYPES[filterValue];
	  } else if (filterName === 'productionLocation') {
	    text = _text2.default.MAPPINGS.PRODUCTION_LOCATIONS[filterValue];
	  } else if (filterName === 'productionMethod') {
	    text = _text2.default.MAPPINGS.PRODUCTION_METHODS[filterValue];
	  } else {
	    text = filterValue;
	  }
	
	  return text || 'Unknown';
	};
	
	exports.default = textMapping;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-glass-js-1c60b087d07e55200509.js